import type {CookieRef} from '#app';

export const useStoreCookies = defineStore('StoreCookies', () => {
    const $router = useRouter();
    const {initialize, disableAnalytics} = useGtag();

    const year = new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000);

    const cookies = {
        asked: useCookieAsked(),
        analytic: useCookieAnalytic(),
    } as Cookies;

    const cookieValues = computed(() => {
        return {
            asked: !!cookies.asked.value,
            analytic: !!cookies.analytic.value,
        };
    });

    function initCookies() {
        if (!!cookies.analytic.value) {
            initialize();
        }
    }

    function setCookie(key: keyof Cookies) {
        const cookie = cookies[key];
        const d = new Date();
        cookie.value = String(d.getTime());
        if (key === 'analytic') {
            initialize();
        }
    }

    function removeCookie(key: keyof Cookies) {
        const cookie = cookies[key];
        cookie.value = null;
        if (key === 'analytic') {
            disableAnalytics();
            useCookieGtag().removeAll();
        }
    }

    function enableCookie(key: keyof Cookies) {
        setCookie(key);
    }

    function toggleCookies(key: keyof Cookies) {
        !!cookies[key].value ? removeCookie(key) : setCookie(key);
    }

    function acceptDefaultCookies() {
        setCookie('analytic');
        setCookie('asked');
    }

    function customiseCookieSettings() {
        setCookie('asked');
        $router
            .push({name: 'cookies'})
            .then(() => {})
            .catch(() => {});
    }

    return {
        cookies: cookieValues,
        initCookies,
        enableCookie,
        toggleCookies,
        acceptDefaultCookies,
        customiseCookieSettings,
    };
});

interface Cookies {
    asked: CookieRef<string | null | undefined>;
    analytic: CookieRef<string | null | undefined>;
}
